import styled from "styled-components";

export const WrapStyle = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2rem;
`;
